(() => {
  function applyReevysV6State() {
    const root = document.querySelector('main[data-template*="product"] .product-details');
    const configs = document.querySelectorAll('[data-reevys-pdp-config]');
    const configNode = configs[configs.length - 1];
    if (!root || !configNode) return;

    let config = null;
    try { config = JSON.parse(configNode.textContent); } catch (error) { return; }

    root.classList.toggle('reevys-no-explicit-style-code', !String(config?.styleCode || '').trim());
  }

  document.addEventListener('DOMContentLoaded', applyReevysV6State, { once: true });
  document.addEventListener('shopify:section:load', applyReevysV6State);
  window.addEventListener('pageshow', applyReevysV6State);
  applyReevysV6State();
})();
